@let isMobile = _storeSvc.res().mobileLarge || _storeSvc.res().mobile || _storeSvc.res().tablet;
@let localeObj = _storeSvc.localeObj();
@let room = data();
@let isRoomLoading = isLoading();
@let roomDetailsData = roomDetails();

<!-- --------------------- Room Images Carousel START ---------------------- -->
<ng-template #roomImgCarousel>
  @let images = roomImages();

  @if (images.length > 0) {
    <app-carousel [images]="images" [config]="carouselConfig()" />
  } @else if (room?.extraThumbnailJumboImageUrl && room?.extraThumbnailJumboImageUrl?.length > 0) {
    <img
      class="room-img w-100 h-100"
      [src]="room?.extraThumbnailJumboImageUrl"
      [alt]="room?.imageAltText || room?.name"
    />
  } @else {
    <img
      class="room-fallback-img w-100 h-100 object-fit-cover"
      src="/assets/images/hotel-fallback-img.png"
      [attr.alt]="room?.name + ' Blank Image'"
    />
  }
</ng-template>
<!-- ---------------------- Room Images Carousel END ----------------------- -->

<app-card
  @grow
  [class.expanded]="!isMobile && isExpanded()"
  classes="w-100 card-room-rate-card"
  [padding]="0"
  [marginBottom]="noMarginBottom() ? 0 : isMobile ? 1.25 : 2.5"
  [active]="!isMobile && isExpanded()"
  [noPadding]="noPadding()"
  [noBorder]="noBorder()"
>
  <!-- --------------------------- Room Card Start --------------------------- -->
  <div
    class="room-card d-flex"
    [class.is-mobile]="isMobile"
    [class.flex-column]="isMobile"
    [class.is-child-card]="isChild()"
    [class.opacity-50]="isDisabled()"
    [class.pe-none]="isDisabled()"
  >
    <div class="room-images overflow-hidden" [class.w-100]="isMobile" (click)="getRoomDetails(true)" role="button"
    >
      @if (isRoomLoading) {
        <div class="room-images-skeleton w-100 h-100">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'100%'"
            [height]="isMobile ? '200px' : '100%'"
            [fullHeight]="true"
            [fullWidth]="true"
          />
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="roomImgCarousel" />
      }
    </div>

    <div
      class="room-info d-flex flex-column align-items-start"
      [class.w-100]="isMobile"
      [class.p-4]="isChild()"
      [class.s-p-40]="!isMobile"
      [class.s-p-20]="isMobile"
    >
      <div class="room-info-header d-flex flex-column w-100">
        @if (isRoomLoading && showRoomsRemainingMessage()) {
          <div class="room-remaining-message-skeleton w-100">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'80%'"
              [fullWidth]="true"
              [height]="'1rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          </div>
        } @else if (!isRoomLoading && showRoomsRemainingMessage()) {
          <div class="room-remaining-message w-100">
            <app-tag tagId="rooms-remaining" variant="danger" icon="fa fa-bolt" [label]="roomsRemainingMessage()" />
          </div>
        }

        @let roomsBookedMsg = roomsBookedMessage();
        @if (isRoomLoading && showRoomsBookedMessage()) {
          <div class="room-booked-message-skeleton w-100">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'90%'"
              [fullWidth]="true"
              [height]="'1rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          </div>
        } @else if (!isRoomLoading && showRoomsBookedMessage() && roomsBookedMsg) {
          <div class="room-booked-message w-100">
            <app-tag tagId="rooms-booked" variant="warning" icon="fa fa-clock" [label]="roomsBookedMsg" />
          </div>
        }

        @if (isRoomLoading) {
          <div class="room-name-skeleton w-100 mb-3">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'100%'"
              [fullWidth]="true"
              [height]="'2rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          </div>
        } @else {
          <h2 class="room-name mb-3">{{ room.name }}</h2>
        }
      </div>

      @if (!isMobile && isRoomLoading) {
        <div class="room-description-skeleton w-100 mb-4">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'100%'"
            [fullWidth]="true"
            [height]="'1rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0.75rem'"
          />
          <app-skeleton-loader-item
            [count]="1"
            [width]="'100%'"
            [fullWidth]="true"
            [height]="'1rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0.75rem'"
          />
          <app-skeleton-loader-item
            [count]="1"
            [width]="'75%'"
            [fullWidth]="true"
            [height]="'1rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0'"
          />
        </div>
      } @else if (!isMobile && showRoomDescription()) {
        <p class="room-description mb-4" [innerHTML]="room?.shortDescription | safeHtml"></p>
      }

      @if (!isMobile && isRoomLoading && showAmenities()) {
        <div class="room-amenities-skeleton w-100 mb-3 d-flex flex-wrap gap-3">
          @for (amenity of [1, 2, 3, 4]; track amenity; let amenityIndex = $index) {
            <app-skeleton-loader-item
              class="room-amenity-skeleton col-5 pe-4"
              [count]="1"
              [width]="'100%'"
              [fullWidth]="true"
              [height]="'1.25rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          }
        </div>
      } @else if (!isMobile && showAmenities() && roomAmenities().length > 0) {
        <div class="room-amenities w-100 mb-3">
          <app-amenities-list [amenities]="roomAmenities()" [amenityType]="amenityType()" />
        </div>
      }

      @if (roomBedTypes().length > 0) {
        <div class="room-bedtypes-select-container position-relative w-100 mb-3">
          <button
            class="room-bedtype-dropdown-btn w-100 borders-color corners"
            type="button"
            (click)="bedTypeDropdown.isOpen() ? bedTypeDropdown.isOpen.set(false) : bedTypeDropdown.isOpen.set(true)"
            [disabled]="isAddToCartInProgress()"
          >
            <div class="room-bedtype-dropdown-btn-content d-flex align-items-center gap-2">
              @if (selectedBedType()?.iconSrc) {
                <img class="room-bedtype-icon" [src]="selectedBedType()?.iconSrc" [alt]="selectedBedType()?.value" />
              }
              <span class="room-bedtype-label">{{ selectedBedType()?.value }}</span>
            </div>

            <i
              class="room-bedtype-dropdown-icon fa-regular"
              aria-hidden="true"
              [class.fa-chevron-up]="bedTypeDropdown.isOpen()"
              [class.fa-chevron-down]="!bedTypeDropdown.isOpen()"
            ></i>
          </button>
          <app-dropdown
            #bedTypeDropdown="dropdown"
            class="position-absolute w-100"
            [items]="roomBedTypes()"
            [id]="'bed-type-dropdown'"
            [useExternalTrigger]="true"
            (closeDropdownEvent)="onBedTypeSelected($event)"
          />
        </div>
      }

      @if (!hideRoomDetails()) {
        @if (isRoomLoading) {
          <div class="room-details-link-skeleton w-100">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'40%'"
              [fullWidth]="true"
              [height]="'2.5rem'"
              [borderRadius]="'var(--button-border-radius)'"
              [marginBottom]="'0'"
            />
          </div>
        } @else {
          <div [id]="'room-details-link-' + room.code">
            <app-button
              variant="link"
              [label]="
                isChild()
                  ? localeObj?.tf_2_RoomList_viewRoomAndPricingDetails_link
                  : localeObj?.tf_2_RoomList_viewRoomDetails_link
              "
              [isLoading]="isRoomDetailsLoading()"
              (onClickEvent)="getRoomDetails(true)"
            />
          </div>
        }
      }
    </div>

    <div
      class="room-rate-info d-flex gap-4"
      [ngClass]="{
        'w-100 flex-row justify-content-between align-items-center s-px-20 s-pb-20 s-pt-10': isMobile,
        'flex-column justify-content-center s-p-40': !isMobile,
        'p-4': isChild(),
      }"
    >
      <div class="room-rate-info-content w-100">
        @let pricingData = pricing();
        @let pricingType =
          _shoppingCartSvc.showAverageNightlyRate()
            ? localeObj?.tf_2_RoomList_roomDetails_perNight
            : localeObj?.tf_2_RoomList_roomDetails_perStay;
        @let dprTagLine = room?.dprTagLine;

        @let discountedPrice =
          _storeSvc.getDiscountedRatePlanPrice(
            data() || {},
            _storeSvc.currConf()?.code,
            _shoppingCartSvc.showTaxesInDisplayPrice()
          );

        @let avgPrice =
          _storeSvc.getAvgRatePlanPrice(data(), _storeSvc.currConf()?.code, _shoppingCartSvc.showTaxesInDisplayPrice());

        @if (isRoomLoading) {
          <div class="from-price-label-skeleton w-100 mb-1">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'75%'"
              [fullWidth]="true"
              [height]="'1rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          </div>
        } @else {
          <div class="from-price-row mb-1">
            @if (!pricingData?.hasComplimentaryRate && !pricingData?.hasPartialCompRate) {
              <span class="from-price-label" [innerHTML]="localeObj?.tf_2_RoomList_roomDetails_fromPrice"></span>
            }

            @if (discountedPrice > 0 && avgPrice > discountedPrice) {
              <del class="from-price-value" [innerHTML]="_storeSvc.priceFormat(avgPrice)"></del>
            }
          </div>
        }

        <div class="actual-price-row d-flex align-items-center flex-wrap gap-1 mb-1">
          @if (isRoomLoading) {
            <div class="actual-price-value-skeleton w-100 mb-1">
              <app-skeleton-loader-item
                [count]="1"
                [width]="'100%'"
                [fullWidth]="true"
                [height]="'2rem'"
                [borderRadius]="'4px'"
                [marginBottom]="'0'"
              />
            </div>
          } @else {
            @if (pricingData?.hasComplimentaryRate || pricingData?.hasPartialCompRate) {
              <img
                class="complimentary-icon"
                [src]="_storeSvc.complimentaryIcon()"
                [alt]="localeObj?.tf_2_RoomList_Complimentary_text"
              />
            }
            @if (pricingData?.hasComplimentaryRate) {
              <span class="large-font-size" [innerHTML]="localeObj?.tf_2_RoomList_Complimentary_text"> </span>
            } @else if (pricingData?.hasPartialCompRate) {
              <span class="default-font-size pb-3" [innerHTML]="localeObj?.tf_2_RoomList_availableComplimentaryNight_text">
              </span>
            } @else {
              <span
                class="actual-price-value price-color"
                [innerHTML]="_storeSvc.priceFormat(discountedPrice || avgPrice)"
              >
              </span>
              <span class="pricing-type" [innerHTML]="pricingType"></span>
            }
          }
        </div>

        @if (isRoomLoading) {
          <div class="tax-msg-row mb-3">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'100%'"
              [fullWidth]="true"
              [height]="'1rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          </div>
        } @else {
          <div class="tax-msg-row">
            <span class="tax-msg-label" [innerHTML]="pricingData?.taxDisplay | safeHtml"></span>
          </div>
        }

        @if (showDPRMessage() && isRoomLoading) {
          <div class="dpr-tag-skeleton w-100">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'75%'"
              [fullWidth]="true"
              [height]="'1rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          </div>
        } @else if (showDPRMessage() && dprTagLine && dprTagLine?.length > 0) {
          <div class="dpr-row mt-3">
            <app-tag tagId="dpr" variant="success" icon="fa fa-badge-percent" [label]="dprTagLine" />
          </div>
        }
      </div>

      <div
        class="room-rate-action col-auto"
        [class.w-50]="isMobile && isRoomLoading"
        [class.w-100]="!isMobile && isRoomLoading"
      >
        @if (isChild() && !isRoomLoading) {
          <app-button
            variant="primary"
            [label]="isMobile ? localeObj?.tf_2_RoomList_select : localeObj?.tf_2_RoomList_selectRoom"
            [isLoading]="isAddToCartInProgress()"
            [isDisabled]="isAddToCartInProgress()"
            (onClickEvent)="selectRoom()"
          />
        } @else {
          @if (isRoomLoading) {
            <div class="room-rate-action-skeleton w-100">
              <app-skeleton-loader-item
                [count]="1"
                [width]="isMobile ? '100%' : '75%'"
                [fullWidth]="true"
                [height]="'2.5rem'"
                [borderRadius]="'var(--button-border-radius)'"
                [marginBottom]="'0'"
              />
            </div>
          } @else {
            <app-button
              [variant]="isExpanded() ? 'secondary' : 'primary'"
              [label]="
                !isMobile && isExpanded() ? localeObj?.tf_2_RoomList_hideRates : localeObj?.tf_2_RoomList_viewRates
              "
              (onClickEvent)="!isMobile && isExpanded() ? hideItems() : viewItems()"
              [isLoading]="!isMobile && isItemsLoading()"
            />
          }
        }
      </div>
    </div>
  </div>

  @if (isExpanded() && !isMobile && items().length > 0) {
    <div
      @grow
      class="room-rates-container"
      #roomRatesContainer
      [style.padding.rem]="isMobile ? 1.25 : 2.5"
      tabindex="-1"
      [attr.aria-label]="`${localeObj?.tf5_room_rates_for} ${data()?.name}`"
    >
      @for (item of items(); track index; let index = $index; let isLast = $last) {
        <app-room-rate-card
          [data]="item"
          [index]="index"
          [isChild]="true"
          [showDetails]="true"
          [noPadding]="true"
          [noBorder]="true"
          [noMarginBottom]="true"
          (onRoomRateSelected)="selectRoomRate(item)"
        />

        @if (!isLast) {
          <hr class="room-rates-separator opacity-100" />
        }
      }
    </div>
  }

  <!-- ---------------------------- Room Card END ---------------------------- -->
</app-card>

<!-- ------------------ Room Rates List for Mobile START ------------------- -->
<ng-template #roomRatesListContent>
  <div class="room-rates-list-mobile-content">
    <div class="room-images position-relative">
      <ng-container [ngTemplateOutlet]="roomImgCarousel" />
      <app-button
        class="room-rates-list-mobile-close-btn"
        variant="close"
        label="Close Button"
        (onClickEvent)="closeRoomRatesListMobile()"
        [classes]="'neutral-white-color-bg'"
      />
    </div>

    <div class="room-info s-p-20">
      @if (showRoomsRemainingMessage()) {
        <div class="s-mb-12">
          <app-tag tagId="rooms-remaining" variant="danger" icon="fa fa-bolt" [label]="roomsRemainingMessage()" />
        </div>
      }

      <h2 class="room-name s-mb-16">{{ room.name }}</h2>

      @if (!hideRoomDetails()) {
        <div [id]="'room-details-link-' + room.code">
          <app-button
            variant="link"
            [label]="
              isChild()
                ? localeObj?.tf_2_RoomList_viewRoomAndPricingDetails_link
                : localeObj?.tf_2_RoomList_viewRoomDetails_link
            "
            [isLoading]="isRoomDetailsLoading()"
            (onClickEvent)="getRoomDetails()"
          />
        </div>
      }
    </div>

    <div class="rates-list d-flex flex-column s-pt-12 s-pb-20 s-px-20">
      @if (isItemsLoading()) {
        @for (item of [0, 1, 2]; track index; let index = $index; let isLast = $last) {
          <app-room-rate-card
            [class.s-mb-20]="!isLast"
            [data]="item"
            [index]="index"
            [isChild]="true"
            [isLoading]="true"
            [noMarginBottom]="true"
          />
        }
      } @else {
        @for (item of items(); track index; let index = $index; let isLast = $last) {
          <app-room-rate-card
            [class.s-mb-20]="!isLast"
            [data]="item"
            [index]="index"
            [isChild]="true"
            [isLoading]="false"
            [noMarginBottom]="true"
            (onRoomRateSelected)="selectRoomRate(item)"
          />
        }
      }
    </div>
  </div>
</ng-template>
<!-- ------------------- Room Rates List for Mobile END -------------------- -->

<!-- ---------------------- Room Details START ----------------------- -->
<ng-template #roomDetailsContent>
  @if (isChild()) {
    <div class="s-pb-32">
      <app-nav-tabs
        [tabs]="roomDetailsNavTabs()"
        [activeTab]="roomDetailsActiveTab()"
        (onTabChange)="roomDetailsActiveTab.set($event)"
      />
    </div>
  }

  @if (!isChild() || (isChild() && roomDetailsActiveTab() === 'ROOM_DETAILS')) {
    <!-- --------------------- Room Detaits Content START ---------------------- -->
    <div class="room-details-content">
      <div
        class="mb-4 room-details-images overflow-hidden corners"
      >
        <ng-container [ngTemplateOutlet]="roomImgCarousel" />
      </div>

      @if (room?.longDescription && room?.longDescription?.length > 0) {
        <div class="room-details-description mt-3" [innerHTML]="room?.longDescription | safeHtml"></div>
      }

      @if ((roomDetailsData?.roomSize && roomDetailsData?.roomSizeUnits) || roomDetailsData?.maxGuestsLabel) {
        <div class="room-details-meta mt-3">
          @if (roomDetailsData?.roomSize && roomDetailsData?.roomSizeUnits) {
            @if (roomDetailsData?.roomSizeUnits === 'Square Feet') {
              <span
                [innerHTML]="
                  _commonSvc?.fillMessage(localeObj?.tf_2_RoomList_roomDetails_sizeInSqFt, [roomDetailsData?.roomSize])
                "
              ></span>
            } @else {
              <span
                [innerHTML]="
                  _commonSvc?.fillMessage(localeObj?.tf_2_RoomList_roomDetails_sizeInSqM, [roomDetailsData?.roomSize])
                "
              ></span>
            }
            <span class="separator mx-2" aria-hidden="true">&bull;</span>
          }

          @if (roomDetailsData?.maxGuestsLabel) {
            <span>{{ roomDetailsData?.maxGuestsLabel }}</span>
          }
        </div>
      }

      @if (room?.amenities && room?.amenities?.length > 0) {
        <div class="room-amenities-container mt-4">
          <app-amenities-list [amenities]="roomAmenities()" [limitAmenities]="false" />
        </div>
      }

      @if (room?.amenities && room?.amenities?.length > 0) {
        <hr class="hr my-4" />
        <div class="other-amenities-container">
          <h5 class="other-amenities-title mb-3 font-weight-semibold large-font-size" [innerHTML]="localeObj?.tf_2_RoomList_roomDetails_otherAmenities"></h5>

          <app-amenities-list [amenities]="otherAmenities()" [limitAmenities]="false" />
        </div>
      }

      @if (roomDetailsData?.threeSixtyImages && roomDetailsData?.threeSixtyImages?.length > 0) {
        <hr class="hr my-4" />
        <div class="room-three-sixty-container mt-4">
          <h5 class="room-three-sixty-title mb-3 font-weight-semibold large-font-size" [innerHTML]="localeObj?.tf_2_RoomList_roomDetails_360Tour"></h5>

          @defer (on viewport; prefetch on idle) {
            <app-room-360-tour [threeSixtyImages]="roomDetailsData?.threeSixtyImages" />
          } @placeholder (minimum 1500ms) {
            <div
              class="room-360-tour-skeleton w-100 overflow-hidden corners"
            >
              <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100 text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading 360 tour...</span>
                </div>
                <p class="mt-2">Loading 360 tour...</p>
              </div>
            </div>
          } @error {
            <div
              class="room-360-tour-error w-100 overflow-hidden corners"
            >
              <div
                class="alert alert-warning m-0 d-flex flex-column align-items-center justify-content-center w-100 h-100 text-center"
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Unable to load 360 tour...</span>
                </div>
                <p class="mt-2">Unable to load 360 tour</p>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <!-- ---------------------- Room Details Content END ----------------------- -->
  } @else {
    <div class="room-rate-price-breakdown">
      <app-price-breakdown [ratePlan]="room" />
    </div>
  }
</ng-template>

<!-- ----------------------- Room Details Modal END ------------------------ -->

<app-side-panel [id]="'room-details-side-panel'" [title]="data()?.name" />

<app-side-panel [id]="'room-rates-list-mobile'" [hideHeader]="true" [fullMaxHeight]="true" />
